const lang = {
    "Confirm Password": "确认密码",
    "Next": "下一页",
    "Please enter a four-digit password.": "请输入一个四位数的密码。",
    "That's the wrong password! Please re-enter.": "密码错误，请重新输入",
    "Enter Password": "输入密码",
    "Please come back after checking.": "请检查后回来。",
    "Please connect using the QR code.": "请使用QR码连接。",
    "Expired QR Code": "已过期QR码",
    "Invalid access.": "无效的访问权限。",
    "An error has occurred.": "发生错误",
    "Your data has been deleted.": "您的数据已被删除。",
    "To meet the new Virtual Smile, please request a new QR code.": "为了满足新的Virtual Smile，请申请新的QR码。",
    "Complete Setup": "完成设置",
    "To protect your privacy, you'll need to agree to use it and set a password.": "为了保护您的隐私，您需要同意使用并设置密码。",
    "entry.button.set_password": "登录按钮设置密码",
    "Consent is required to set a password.": "设置密码需要用户同意",
    "I have received an explanation of the Ray Virtual Smile service by the hospital and understand the information provided.": "我已收到诊所关于瑞丽虚拟微笑服务的解释，并理解所提供的信息。",
    "I have been given the opportunity by the hospital to ask questions about Ray Virtual Smile service.": "医院给了我向瑞丽虚拟微笑服务提问的机会。",
    "I voluntarily agree the proposed use of data in sharing.": "本人特此同意与该诊所分享我的个人资料。",
    "I agree that managing this password is solely my responsible.": "本人在此确认本人理解并接受本人对上述服务的密码管理责任。",
    "I understand I can withdraw at any time without giving reasons and without being questioned, and that I will not be penalized for withdrawing.": "我知道，我可以在任何时候通过联系该诊所来撤回此同意书。",
    "Consent": "同意",
    "Set Password": "设置密码",
    "Please enter 4 numbers for your password.": "请输入一个四位数的密码。",
    "Confirm Password.": "确认密码",
    "Please enter your password again.": "请再次输入您的密码。",
    "Please wait for a moment.": "请稍等",
    "Enter password": "输入密码",
    "Please enter your password.": "请输入密码。",
    "The connection was rejected due to an abnormal access.": "由于访问异常，连接被拒绝。",
    "Setting": "设置",
    "Language": "语言",
    "Delete All Items": "删除所有数据",
    "Are you sure you want to delete? Erased data cannot be recovered.": "您确定您要继续进行删除吗？一旦被删除，这些数据将无法恢复。",
    "Please enter your password to delete the data.": "根据用户的要求，需要进行密码确认，才能删除数据。",
    "This data was deleted by requesting of user.": "该数据已按用户的要求被删除",
    "Make sure RAYTeams is logged in.": "请确保RAYTeams已登录。",
    "\"Ray Virtual Smile\" could not be found, please create new one.": "找不到“瑞丽虚拟微笑”。请新建。",
    "Data uploads are delayed due to poor network connectivity": "ネットワーク接続が悪いため、データのアップロードに時間がかかっています。",
    "Confirm": "联系我们",
    "Delete": "删除",
};

const trans = {
    ...lang,
}

export default trans;